import type * as React from "react";

import { cn } from "../cn";

export type StatGridProps = React.ComponentProps<"div"> & {
  /**
   * `dense` (Chart UX pass 2026-10-21): the KPI strip over a finance table, 12 px apart with
   * no vertical margin of its own, for `StatTile size="sm"`.
   */
  dense?: boolean;
};

/**
 * Design spec §6.6: four equal columns 16 px apart (two, 12 apart, below 768), 20 px above and
 * below. Holds `StatTile`s.
 */
export function StatGrid({ dense = false, className, ...props }: StatGridProps) {
  return (
    <div
      data-slot="stat-grid"
      data-dense={dense || undefined}
      className={cn(
        "grid grid-cols-4 max-md:grid-cols-2",
        dense ? "gap-3 max-md:gap-2" : "my-5 gap-4 max-md:gap-3",
        className,
      )}
      {...props}
    />
  );
}
